<template>
  <div :v-bind="randomWord">
    <div class="word" @click="getRandomWord">
      <h1>{{ randomWord.Title }}</h1>
      <h2>{{ randomWord.Subtitle }}</h2>
    </div>
    <Sponsor :spsr="spsr" :company="company" :link="link" :logo="logo" :title="title" :subtitle="subtitle" />
  </div>
</template>

<script>
import jsondata from "../assets/data.json";
import spsrdata from "../assets/spsr.json";
import Sponsor from "../components/Sponsor";

export default {
  name: "word",
  components: { Sponsor },
  data: function () {
    return {
      randomWord: [],
      spsr: "",
      company: "",
      link: "",
      logo: "",
      title: "",
      subtitle: ""
    };
  },
  mounted: function () {
    this.getRandomWord();

    setInterval(
      function () {
        this.getRandomWord();
      }.bind(this),
      900000
    );
  },
  methods: {
    getRandomWord: function () {
      const idx = Math.floor(Math.random() * jsondata.length);
      this.randomWord = jsondata[idx];
      this.spsr = this.randomWord.Spsr;
      this.getSpnsrData();
    },
    getSpnsrData: function () {
      const results = spsrdata.find(sponsor => sponsor.spsr === this.spsr);
      // console.log(results);
      this.company = results.company;
      this.link = results.link;
      this.logo = results.logo;
      this.title = results.title;
      this.subtitle = results.subtitle;
    }
  }
};
</script>

<style>
.word {
  width: 100vw;
  padding: 10px;
}

h1 {
  font-family: "OpticianSans", sans-serif;
  font-size: 10vw;
  font-weight: 700;
  margin-bottom: 0px;
  text-align: center;
}

h2 {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
  font-size: 5vw;
  font-weight: 300;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Word.vue